jQuery_T4NT(document).ready(function($) {

  	 console.log("from custom 1");	
		new Shopify.CountryProvinceSelector("country","province",{hideElement:"address_province_container"});
  		console.log("from custom");	
     /**
     * Variant selection changed
     */
	  $( document ).on( "variant:change", function( evt, variant ) {
	    //console.log( variant );
	  });

  		
});

  setTimeout(function() {
    var cookieLawDiv = document.querySelector('#shopify-section-cookies_law.pp_onshow');
    if (cookieLawDiv) {
      cookieLawDiv.style.display = 'none';
    }
  }, 20000); // 20000 ms = 20 segundos


var tabs = document.getElementsByClassName("actividad-option-img");
var categorias = document.querySelectorAll('.categoria-filtro');

function changeTab(tabIndex) {
  // Ocultar todos los contenidos de las pestañas
  for (var i = 0; i < tabs.length; i++) {
    tabs[i].classList.remove("active");
  }

  tabs[tabIndex].classList.add("active");
}



function openModal(position) {
    document.getElementById('myModal' + position).style.display = 'block';
}

// Función para cerrar el modal
function closeModal(position) {
    document.getElementById('myModal' + position).style.display = 'none';
}
    
  // Cerrar el modal si el usuario hace clic fuera del contenido del modal
  window.onclick = function(event) {
      var modal = document.getElementById('myModal');
      if (event.target == modal) {
          modal.style.display = 'none';
      }
  };
  







  
 

